// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2OIxG","footer":"ReportModalFilter_footer__2L5Ls"};